import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path_header: string = "header";
const path_footer: string = "footer";

export type formStateHeader = {
    header_name: string;
    header_name_color: string;
    header_name_desc: string;
    header_name_desc_color: string;
    header_desc: string;
    header_desc_color: string;
    id_media_file: number | null;
}

export type formStateFooter = {
    footer_name: string;
    footer_name_color: string;
    footer_desc: string;
    footer_sub_text: string;
    footer_sub_text_color: string;
    footer_desc_color: string;
    footer_tel: string;
    footer_contact_suggestions: string;
    footer_copyright: string;
    footer_website: string;
    id_media_file: number | null;
    footer_menu: { id_footer_menu: number, id_menu: number }[];
    footer_social_media: { id_footer_social_media: number, id_social_media: number }[];
}

export class WebsiteStructureApi extends BaseAPI {
    // HEADER
    static createdHeader(body: formStateHeader): Promise<AxiosResponse> {
        return this.api.post(`${path_header}`, body)
    }
    static updatedHeader(id_header: number, body: formStateHeader): Promise<AxiosResponse> {
        return this.api.patch(`${path_header}/${id_header}`, body)
    }
    static getHeader(): Promise<AxiosResponse> {
        return this.api.get(`${path_header}`)
    }

    // FOOTER
    static getFooter(): Promise<AxiosResponse> {
        return this.api.get(`${path_footer}`)
    }
    static createdFooter(body: formStateFooter): Promise<AxiosResponse> {
        return this.api.post(`${path_footer}`, body)
    }
    static updatedFooter(id_footer: number, body: formStateFooter): Promise<AxiosResponse> {
        return this.api.patch(`${path_footer}/${id_footer}`, body)
    }
}